export default __webpack_public_path__ + "static/media/shmagigavashelashvili.cv.05eafd8a.pdf";